import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrentWorkflowService {

  constructor() { }

  private workflowSubject = new BehaviorSubject<any>(null);
  private isWOCApproved = new BehaviorSubject<boolean>(false);


  workflow$ = this.workflowSubject.asObservable();
  wocApproval$ = this.isWOCApproved.asObservable();

  updateWorkflow(newWorkflowData: any) {
    this.workflowSubject.next(newWorkflowData);
  }

  getisWocApproved() {
    return this.isWOCApproved;
  }

  setisWocApproved(value: boolean): void {
    this.isWOCApproved.next(value);
  }
}
